import { useNavigate, useRouterState } from '@tanstack/react-router';
import { lastMonths } from '@blimo/shared';

/**
 * Current period (URL or default "last 12 months", like the API) plus a setter that patches the
 * URL search (validated by `financeSearch` from @blimo/shared).
 * @param {Record<string, any>} search
 */
export function useFinanceSearch(search) {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const fallback = lastMonths(12);
  const period = { from: search.from ?? fallback.from, to: search.to ?? fallback.to };
  /** @param {Record<string, string|undefined>} patch */
  const update = (patch) =>
    navigate({
      to: pathname,
      search: (prev) => Object.fromEntries(Object.entries({ ...prev, ...patch }).filter(([, v]) => v !== undefined && v !== '')),
      replace: true,
    });
  return { period, update };
}
